import React from 'react';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { decodeTokens, getAuthInfo } from '../../utils/auth';
import { getAppConfig } from '../../utils/configuration';

interface propsChildren {
    children: JSX.Element;
}
let LDProvider: ({ children }: { children: ReactNode; }) => ReactElement;


const LaunchDarklyFeatureFlagInit = ({ children }: propsChildren) => {
  const { xbsEnvironment, launchDarklyEnv } = getAppConfig();
  const [isProviderReady, setConfigurationLoaded] = useState(false);
  const { authToken } = getAuthInfo();
  const userData = decodeTokens(authToken);

  useEffect(() => {
    if (!isProviderReady) {
      (async () => {
        LDProvider = await asyncWithLDProvider({
          clientSideID: launchDarklyEnv[xbsEnvironment],
          user: {
            key: userData?.userId
          },
        });
        setConfigurationLoaded(true);
      })();
    }
  }, [isProviderReady, xbsEnvironment, launchDarklyEnv, userData?.userId]);
  return isProviderReady ? <LDProvider>{children}</LDProvider> : 'Loading';
};

export default LaunchDarklyFeatureFlagInit;